import { ReactComponent as ChevronDownSvg } from '../../../../assets/icons/ChevronDown.svg';

import { createIconComponent } from './createIconComponent';

export const ChevronDownIcon = createIconComponent(ChevronDownSvg);
